export default __webpack_public_path__ + "static/media/emails-animate.00312437.svg";